import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import CategoriesForm from 'modules/surveys/components/Form/QuestionCategories/CategoriesForm'

interface Props {
  onClose: () => void
  onSubmit: (data: Record<string, unknown>) => Promise<unknown>
}

export default function NewCategoryModal({ onClose, onSubmit }: Props) {
  return (
    <CategoriesForm
      modalIllustration="add-block"
      modalTitle={i18n.t('surveys.form.question_categories.new.title')}
      modalDescription={i18n.t('surveys.form.question_categories.new.description')}
      modalLabel={i18n.t('surveys.form.question_categories.new.label')}
      modalPlaceholder={i18n.t('surveys.form.question_categories.new.label_placeholder')}
      modalButton={i18n.t('surveys.form.question_categories.new.submit')}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}
